import CreativeImg2ImgPanel from './CreativeImg2Img';
import TemplateReplacePanel from './TemplateReplace';
import MaterialHDPanel from './MaterialHD';
import SkinHDPanel from './SkinHD';
import ImageUpscalePanel from './ImageUpscale';
import RelightPanel from './Relight';

// 功能 key → 面板组件 映射（每新增一种功能面板在这里注册）
export const PANEL_MAP = {
    creativeImg2Img: CreativeImg2ImgPanel,
    templateReplace: TemplateReplacePanel,
    materialHD: MaterialHDPanel,
    skinHD: SkinHDPanel,
    imageUpscale: ImageUpscalePanel,
    relight: RelightPanel,
};

export const getPanelComponent = (functionKey) => PANEL_MAP[functionKey] || null;

export { default as CreativeImg2ImgPanel } from './CreativeImg2Img';
export { default as RelightPanel } from './Relight';
